document.addEventListener("DOMContentLoaded", () => {
   let searchDrawer = document.querySelector('.cart__summary');
  
            if (searchDrawer) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                           BSS_B2B.observer.cartSubject.listenCartCheckout() 
                        }
                    });
                });
                observer.observe(searchDrawer, {childList: true});
            }

            let searchDrawer1 = document.querySelector('cart-drawer');
            
            if (searchDrawer1) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                           
                           BSS_B2B.observer.cartSubject.listenCartCheckout() 
                        }
                    });
                });
                observer.observe(searchDrawer1, {childList: true});
            }

            const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 




});

const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector(".ajaxcart__footer-price");
    const taxExWrapper = document.querySelector(".bss-b2b-tax-ex-wrapper.bss-config-header");

    if (footerPrice && taxExWrapper) {
      footerPrice.parentNode.insertBefore(taxExWrapper, footerPrice);
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(".bss-b2b-vat-input-wrapper");

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

function handleTEBox() {
  const translations = BSS_B2B.te.teTranslations;
  const headerText = document.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector(
    ".bss-b2b-translation-vat-form_subtitle_text"
  );
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_success_message"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_success_message_us_ein"
    ),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || "";
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || "";
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_error_message"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_error_message_us_ein"
    ),
    document.querySelector(
      ".bss-b2b-translation-vat-form_validate_country_code_message"
    ),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || "";
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || "";
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || "";
          break;
      }
    }
  });
}

document.addEventListener('cart:rerendered', ()=> {
  if(BSS_B2B){
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
}) 

